
import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { Cat } from './Cat';
import React , {useState} from 'react';

let positionY;
let positionX;
const MiniModel = () =>{
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (event) => {
    const { clientX, clientY} = event;
    setMousePosition({ x: clientX, y: clientY});
    positionX = (mousePosition.x / window.innerWidth) * 2 - 1;
    positionY = (mousePosition.y / window.innerHeight ) * 2 ;
    if(positionY >= 0.6){
        positionY = 0.6;
      }
    };
    window.addEventListener('mousemove', handleMouseMove);
    return (
        <div>
        <Canvas>
        <ambientLight intensity={1}/>
          <pointLight  color="pink"  position={[5, 5, 5]} />
            <Suspense fallback={null}>
            <Cat rotation-y={positionX} rotation-x={positionY}/>
          </Suspense>
        </Canvas>

        </div>
        
      );
    }

export default MiniModel;

